









































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import searchInput from "@/components/searchInput.vue";
import ShortHeaderLayout from "@/layouts/shortHeaderLayout.vue";
import abpbase from "@/lib/abpbase";
import BasicPage from "@/layouts/basicPage.vue";
import PrimaryPage from "@/layouts/primaryPage.vue";

@Component({
    components: {PrimaryPage, BasicPage, ShortHeaderLayout, searchInput}
})
export default class userCenterIndex extends abpbase {
    customActiveKey = '0'
    hasHeight: boolean = true;
    device: string = '';
    selectedKeys = [];
    openKeys = [];

    defRoutes = [{
        path: 'train',
        breadcrumbName: '用户中心',
    }]

    handleTabClick(e) {
        this.customActiveKey = e;
    }

    updateMenu() {
        const routes = this.$route.matched.concat()
        this.selectedKeys = [routes.pop().path]
    }

    mounted() {
        this.updateMenu()
    }

    @Watch("$route")
    routerChange(newVal) {
        this.updateMenu()
    }

    onOpenChange(openKeys) {
        this.openKeys = openKeys
    }

}
